import ApiService from '@/services/api'

const state = {
  cores: [
    { label: 'Amarelo', value: 'Amarelo' },
    { label: 'Azul', value: 'Azul' },
    { label: 'Roxo', value: 'Roxo' },
    { label: 'Verde', value: 'Verde' },
    { label: 'Vermelho', value: 'Vermelho' },
    { label: 'Rosa', value: 'Rosa' }
  ],
  niveis: [
    { label: 'Iniciando', value: 'Iniciando' },
    { label: 'Aprendiz', value: 'Aprendiz' },
    { label: 'Praticante', value: 'Praticante' },
    { label: 'Profissional', value: 'Profissional' },
    { label: 'Professor', value: 'Professor' },
    { label: 'Mestre', value: 'Mestre' }
  ],
  habilidades: [
    { label: 'HTML', value: 'HTML' },
    { label: 'CSS', value: 'CSS' },
    { label: 'JavaScript', value: 'JavaScript' },
    { label: 'Vue.js', value: 'Vue.js' },
    { label: 'React', value: 'React' },
    { label: 'Angular', value: 'Angular' },
    { label: 'Node.js', value: 'Node.js' },
    { label: 'Python', value: 'Python' },
    { label: 'Java', value: 'Java' },
    { label: 'C#', value: 'C#' },
    { label: 'PHP', value: 'PHP' },
    { label: 'Ruby', value: 'Ruby' },
    { label: 'Swift', value: 'Swift' },
    { label: 'Kotlin', value: 'Kotlin' },
    { label: 'SQL', value: 'SQL' },
    { label: 'NoSQL', value: 'NoSQL' }
  ],

  todasHabilidades: [
    { label: 'HTML', value: 'HTML', nivel: 'Mestre' },
    { label: 'CSS', value: 'CSS', nivel: 'Mestre' },
    { label: 'JavaScript', value: 'JavaScript', nivel: 'Professor' },
    { label: 'Vue.js', value: 'Vue.js', nivel: 'Professor' },
    { label: 'React', value: 'React', nivel: 'Praticante' },
    { label: 'Angular', value: 'Angular', nivel: 'Iniciando' },
    { label: 'Node.js', value: 'Node.js', nivel: 'Profissional' },
  ],

  // Novos estados para Skills da API
  skills: [],
  loadingSkills: false,
  skillsError: null
}

const getters = {
  cores: state => state.cores,
  niveis: state => state.niveis,
  habilidades: state => state.habilidades,
  todasHabilidades: state => state.todasHabilidades,
  
  // Novos getters para Skills da API
  allSkills: state => state.skills,
  skillsCount: state => state.skills.length,
  isLoadingSkills: state => state.loadingSkills,
  skillsError: state => state.skillsError,
  getSkillById: state => id => state.skills.find(skill => skill.id === id),
  getSkillByName: state => name => state.skills.find(skill => 
    skill.name?.toLowerCase() === name.toLowerCase()
  )
}

const mutations = {
  ADICIONAR_HABILIDADE(state, habilidade) {
    // Verifica se a habilidade já existe para evitar duplicatas
    const existe = state.todasHabilidades.find(h => h.value === habilidade.value)
    if (!existe) {
      state.todasHabilidades.push(habilidade)
    }
  },
  
  REMOVER_HABILIDADE(state, habilidadeValue) {
    const index = state.todasHabilidades.findIndex(h => h.value === habilidadeValue)
    if (index !== -1) {
      state.todasHabilidades.splice(index, 1)
    }
  },
  
  ATUALIZAR_HABILIDADE(state, { value, novoNivel, novaLabel }) {
    const habilidade = state.todasHabilidades.find(h => h.value === value)
    if (habilidade) {
      if (novoNivel !== undefined) {
        habilidade.nivel = novoNivel
      }
      if (novaLabel !== undefined) {
        habilidade.label = novaLabel
      }
    }
  },

  // Novas mutations para Skills da API
  SET_SKILLS(state, skills) {
    state.skills = skills
  },
  
  SET_LOADING_SKILLS(state, status) {
    state.loadingSkills = status
  },
  
  SET_SKILLS_ERROR(state, error) {
    state.skillsError = error
  },
  
  CLEAR_SKILLS_ERROR(state) {
    state.skillsError = null
  }
}

const actions = {
  adicionarHabilidade({ commit }, habilidade) {
    commit('ADICIONAR_HABILIDADE', habilidade)
  },
  
  removerHabilidade({ commit }, habilidadeValue) {
    commit('REMOVER_HABILIDADE', habilidadeValue)
  },
  
  atualizarHabilidade({ commit }, payload) {
    commit('ATUALIZAR_HABILIDADE', payload)
  },

  // Nova action para buscar Skills da API
  async fetchSkills({ commit }) {
    commit('SET_LOADING_SKILLS', true)
    commit('CLEAR_SKILLS_ERROR')
    
    try {
      const response = await ApiService.get('/Skill')
      commit('SET_SKILLS', response.data)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Erro ao carregar skills'
      commit('SET_SKILLS_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_LOADING_SKILLS', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
